var map = {
	"./aed.svg": 703,
	"./bh.svg": 9117,
	"./ca.svg": 1099,
	"./ch.svg": 3474,
	"./cny.svg": 9549,
	"./eu.svg": 2629,
	"./gb.svg": 8260,
	"./jpy.svg": 5326,
	"./kw.svg": 9485,
	"./lyd.svg": 3386,
	"./qa.svg": 8157,
	"./sa.svg": 3643,
	"./se.svg": 503,
	"./us.svg": 891
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3711;
module.exports = webpackAsyncContext;